<template>
    <el-drawer
        :title="info.fullName"
        :visible.sync="show"
        direction="btt"
        :before-close="handleClose"
        :destroy-on-close="true"
        :size="this.$tools.mainHeight() + 'px'"
    >
        <div class="info-tab-outer">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="基本信息" name="info">
                    <div class="info-div">
                        <div class="button-bar">
                            <el-button type="primary" size="small" v-if="step == 0" @click="edit">编辑</el-button>
                            <el-button
                                type="primary"
                                size="small"
                                v-if="step == 1"
                                @click="doedit(true)"
                            >保存</el-button>
                            <el-button
                                type="info"
                                size="small"
                                v-if="step == 1"
                                @click="doedit(false)"
                            >取消</el-button>
                        </div>

                        <el-form :model="info" class="main-form">
                            <el-form-item label="所属店铺">{{info.shopName}}</el-form-item>

                            <el-form-item label="销售员">{{info.sellerName}}</el-form-item>

                            <el-form-item label="客户名称">
                                <el-input type="text" v-model="info.fullName" :disabled="step == 0"></el-input>
                            </el-form-item>

                            <el-form-item label="公司名称">
                                <el-input
                                    type="text"
                                    v-model="info.companyName"
                                    :disabled="step == 0"
                                ></el-input>
                            </el-form-item>

                            <el-form-item label="所在城市">
                                <el-input type="text" v-model="info.country" :disabled="step == 0"></el-input>
                            </el-form-item>

                            <el-form-item label="邮箱">
                                <el-input type="text" v-model="info.email" :disabled="step == 0"></el-input>
                            </el-form-item>

                            <el-form-item
                                label="上次订单时间"
                            >{{$tools.timestampToTime(info.finalOrderTime)}}</el-form-item>

                            <el-form-item
                                label="订单统计"
                            >共{{info.orderNumber}}个订单，总计订单金额{{$tools.parsecost(info.totleCost, true)}}$</el-form-item>

                            <el-form-item
                                label="上次回访时间"
                            >{{$tools.timestampToTime(info.feedbackTime)}}</el-form-item>

                            <el-form-item label="回访统计">共回访{{info.feedbackNumber}}次</el-form-item>
                        </el-form>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="订单记录" name="order">
                    <el-table
                        :data="records"
                        stripe
                        style="width: 100%"
                        :height="this.$tools.mainHeight() - 135"
                        class="alibaba-order-table"
                    >
                        <el-table-column prop="shopName" label="所属店铺" width="100"></el-table-column>
                        <el-table-column prop="sellerName" label="销售员" width="100"></el-table-column>
                        <el-table-column prop="buyerName" label="客户名称" width="200"></el-table-column>

                        <el-table-column prop="id" label="订单号" width="200">
                            <template slot-scope="order">
                                {{order.row.id}}
                                <el-tag type="danger" v-if="order.row.tags.indexOf('sample_order') != -1">样</el-tag>
                                <el-tag type="ssuccess" v-if="order.row.isShippingFee == 'Y'">运</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" label="订单状态" width="200"></el-table-column>
                        <el-table-column prop="productStatus" label="生产状态" width="100"></el-table-column>

                        <el-table-column prop="totalAmount" label="订单金额($)" width="100">
                            <template slot-scope="order">{{ $tools.parsecost(order.row.totalAmount, true)}}</template>
                        </el-table-column>

                        <el-table-column prop="shippingFeeAmount" label="运费($)" width="100">
                            <template slot-scope="order">{{ $tools.parsecost(order.row.shippingFeeAmount, true)}}</template>
                        </el-table-column>

                        <el-table-column prop="advanceAmount" label="预付款($)" width="100">
                            <template slot-scope="order">{{ $tools.parsecost(order.row.advanceAmount, true)}}</template>
                        </el-table-column>

                        <el-table-column v-if="isRoot" prop="cost" label="成本(￥)" width="100">
                            <template slot-scope="order">{{ $tools.parsecost(order.row.cost, true)}}</template>
                        </el-table-column>

                        <el-table-column prop="createDate" label="下单时间" width="160">
                            <template
                                slot-scope="order"
                            >{{ $tools.timestampToTime(order.row.createDate)}}</template>
                        </el-table-column>

                        <el-table-column prop="agreedShipmentDate" label="约定发货时间" width="160">
                            <template
                                slot-scope="order"
                            >{{ $tools.timestampToTime(order.row.agreedShipmentDate)}}</template>
                        </el-table-column>
                    </el-table>

                    <el-pagination
                        small
                        layout="total, prev, pager, next"
                        :total="params.total"
                        @current-change="pageorder"
                        :current-page.sync="params.current"
                    ></el-pagination>
                </el-tab-pane>
                <el-tab-pane label="营销记录" name="feed">敬请期待</el-tab-pane>
            </el-tabs>
        </div>
    </el-drawer>
</template>


<script>
export default {
    props: {
        show: { type: Boolean, default: false },
        buyerId: { type: Number, default: null },
        isRoot: { type: Boolean, default: false },
    },
    data() {
        return {
            info: {},
            step: 0,
            activeName: "info",

            records: null,
            params: {
                shopId: null,
                seller: null,
            },
        };
    },
    methods: {
        getInfo() {
            let _this = this;
            _this.$http.post(
                [ _this.isRoot ? "alibaba/buyer/get" : "alibaba/buyer/getMyself", { id: this.buyerId }],
                [
                    function (data) {
                        _this.info = data;
                    },
                ],
                ".alibaba-buyer-table"
            );
        },
        handleClose(done) {
            this.$emit("update:show", false);
            done();
        },
        handleClick(tab) {
            if (tab.name == "order") {
                this.pageorder();
            } else if (ab.name == "info") {
                this.getInfo();
            }
        },
        edit() {
            let _this = this;
            _this.step = 1;
        },
        doedit(action) {
            let _this = this;

            if (action) {
                _this.$http.post(
                    ["alibaba/buyer/save", _this.info],
                    [
                        function (data) {
                            _this.step = 0;
                        },
                    ],
                    ".alibaba-buyer-table"
                );
            } else {
                _this.step = 0;
            }
        },
        pageorder(current) {
            let _this = this;

            if (current) {
                _this.params.current = current;
            }

            _this.params.buyer = _this.buyerId;

            _this.$http.post(
                [
                    _this.isRoot
                        ? "alibaba/order/page"
                        : "alibaba/order/mypage",
                    _this.params,
                ],
                [
                    function (data) {
                        _this.params.total = data.total;
                        _this.records = data.records;
                    },
                ],
                ".alibaba-order-table"
            );
        },
    },
    mounted() {},
    watch: {
        show(val) {
            if (val) {
                this.activeName = "info";
                this.getInfo();
            }
        },
    },
};
</script>

<style lang="scss">
#el-drawer__title {
    margin-bottom: 5px;
    padding: 20px 10px 0;
    font: bold;
}
.info-tab-outer {
    margin: 5px 10px;
}
.info-div {
    overflow: hidden;
}

.main-form {
    width: 1000px;

    .el-form-item {
        float: left;

        .el-form-item__label {
            width: 100px;
        }

        .el-form-item__content {
            width: 400px;
            float: left;
        }
    }
}
</style>